import { render } from "./WCSpinner.vue?vue&type=template&id=64091e24&scoped=true"
import script from "./WCSpinner.vue?vue&type=script&lang=js"
export * from "./WCSpinner.vue?vue&type=script&lang=js"

import "./WCSpinner.vue?vue&type=style&index=0&id=64091e24&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64091e24"]])

export default __exports__